import { Box, Modal, Stack, Typography } from "@mui/material";
import { useLangContext } from "../../../context/langContext";
import compInfos from "./set-new-workspace.json";
import AddNewWorkForm from "../../../forms/add-new-workspace/AddNewWorkspaceForm";
import { useWorkspaceContext } from "../../../context/workspaceContext";

export default function AddNewWorkspaceModalComponent() {
  const { setWorkSpaceModal, workSpaceModal } = useWorkspaceContext();
  const { dir, lang } = useLangContext();

  const handleClose = () => {
    setWorkSpaceModal(false);
  };

  const infos = compInfos[lang];

  return (
    <Modal open={workSpaceModal} onClose={handleClose}>
      <Box
        dir={dir}
        sx={{
          display: "grid",
          placeContent: "center",
          placeItems: "center",
          height: "100vh",
          zIndex: "999990",
        }}
      >
        <Box
          sx={{
            width: { xs: "95vw", md: "35vw" },
            backgroundColor: (theme) => theme.palette.gray.bg,
            pt: "5px",
            pb: "30px",
            px: "20px",
            borderRadius: "16px",
          }}
        >
          <Stack
            p="0"
            m="0"
            boxSizing={"border-box"}
            direction="row"
            alignItems="center"
            width="100%"
            sx={{
              borderBottomStyle: "dashed",
              borderBottomWidth: "2px",
              borderBottomColor: (theme) => theme.palette.gray[400],
            }}
          >
            <Typography
              variant="h6MediumBold"
              component="p"
              sx={{
                width: "100%",
                py: "18px",
                color: (theme) => theme.palette.dominant.main,
              }}
            >
              {infos.title}
            </Typography>
          </Stack>
          <AddNewWorkForm />
        </Box>
      </Box>
    </Modal>
  );
}
